// ==============================|| OVERRIDES - AUTOCOMPLETE ||============================== //

export function Autocomplete(theme) {
  return {
    MuiAutocomplete: {
      styleOverrides: {
        root: {
          "& .MuiAutocomplete-endAdornment": {
            marginTop: "-5px",
          },
        },
      },
    },
  };
}
